import * as React from 'react';
import BootstrapTooltip from 'views/Components/Shared/Components/BootstrapTooltip';

export default function TooltipDescription({ title, description }) {
	return (
		<BootstrapTooltip title={description} placement="top">
			<span>{title}</span>
		</BootstrapTooltip>
	);
}
